import { HowItWorksContent } from "@/components/how-it-works/HowItWorksContent";

/**
 * In-app "How it works" page (authenticated, under the dashboard layout).
 * Renders live impact metrics. The public mirror lives at /how-it-works
 * (src/pages/PublicHowItWorksPage.tsx) and uses the static snapshot.
 */
export function HowItWorksPage() {
  return (
    <div className="p-4 md:p-6 lg:p-8">
      <HowItWorksContent metricsMode="live" />
    </div>
  );
}
